import { connect } from 'react-redux'
import ReconnectionModal from './ReconnectionModal'
import { reconnectRoom } from '../../dataStore/actions/room/room'

const mapStateToProps = state => ({
  twilioConnectionError: state.ui.twilioConnectionError,
  user: state.user.data,
  connectionStatus: state.sessionStatus.roomStatus,
  focused: state.ui.focused
})
const mapDispatchToProps = dispatch => ({
  reconnectRoom: () => dispatch(reconnectRoom())
})

export default connect(mapStateToProps, mapDispatchToProps)(ReconnectionModal)
